import Page from '../../enums/Page';

export default function getPageFromLocation(location) {
  if (/^\/checkout\/?(\?.*)?$/.test(location)) return Page.CHECKOUT;
  
  if (/^\/checkout\/complete\/?/.test(location)) return Page.COMPLETE;
  
  if (/^\/checkout\/processing/.test(location)) return Page.PROCESSING;
  
  if (/^\/checkout\/payment-resolution\/?/.test(location)) return Page.PAYMENT_RESOLUTION;
  
  if (/^\/checkout\/payment-resolved($|\/|\?)+\/?/.test(location)) return Page.PAYMENT_RESOLVED;
  
  if (/^\/checkout\/payment-change($|\/|\?)+\/?/.test(location)) return Page.PAYMENT_CHANGE;
  
  if (/^\/checkout\/payment-changed($|\/|\?)+\/?/.test(location)) return Page.PAYMENT_CHANGED;
}
